import { registerBlockType, getBlockType } from '@wordpress/blocks';
import { useBlockProps, InnerBlocks, RichText } from '@wordpress/block-editor';

if(!getBlockType('preciseinvestigation/accordion')) {
    registerBlockType('preciseinvestigation/accordion', {
        title: 'Accordion',
        icon: 'images-alt',
        category: 'common',
        edit: (props) => editComponent(props),
        save: (props) => saveComponent(props),
    });
}

function editComponent({attributes, setAttributes}) {

    const blockProps = useBlockProps();

    return (
        <div>
            <div>
                <RichText
                    { ...blockProps }
                    value={ attributes.accordionTitle }
                    onChange={ ( content ) => setAttributes( { accordionTitle: content } ) } 
                    placeholder={ ( 'Accordion Title' ) }
                />
            </div>
            <div>
                <InnerBlocks />
            </div>
        </div>
    )
}

function saveComponent({attributes}) {
    return (
        <div x-data="{ open: false }">
            <button type = "button" x-bind:class="open ? 'is-active' : ''" x-on:click="open = ! open">{attributes?.accordionTitle}</button>
            <div x-show="open" x-transition>
                <InnerBlocks.Content />
            </div>
        </div>
    );
}